import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onGenerateReminders, onExportData, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-surface rounded-[14px] p-4 shadow-warm-2xl border border-border">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="h-10 w-10 rounded-lg bg-accent/10 flex items-center justify-center">
              <Icon name="CheckSquare" size={20} color="var(--color-accent)" />
            </div>
            <span className="text-sm font-medium text-foreground font-caption">
              {selectedCount} certificate{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>

          <div className="h-8 w-px bg-border" />

          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" iconName="Mail" iconPosition="left" onClick={onGenerateReminders}>
              Generate Reminders
            </Button>
            <Button variant="outline" size="sm" iconName="Download" iconPosition="left" onClick={onExportData}>
              Export Selected
            </Button>
            <button
              onClick={onClearSelection}
              className="h-10 w-10 rounded-lg bg-input border border-border flex items-center justify-center transition-smooth hover:bg-muted"
              aria-label="Clear selection"
            >
              <Icon name="X" size={20} color="var(--color-muted-foreground)" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;